class UserAgent {
  public static readonly value: string = '';
}

export default UserAgent;
